import * as c from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";

export interface AppWebhookApi {
  getEndpoint(appId: string): Promise<c.AdminAppWebhookEndpoint>;
  upsertEndpoint(appId: string, input: c.AdminAppWebhookUpsertInput): Promise<c.AdminAppWebhookEndpoint>;
  listDeliveries(appId: string, query?: Partial<c.AdminAppWebhookDeliveryListQuery>): Promise<c.AdminAppWebhookDeliveryListResult>;
  sendTest(appId: string): Promise<c.AdminAppWebhookDelivery>;
  retryDelivery(appId: string, deliveryId: string): Promise<c.AdminAppWebhookDelivery>;
}

const qs = (value: object) => new URLSearchParams(Object.entries(value).map(([key, item]) => [key, String(item)])).toString();

export function createHttpAppWebhookApi(options: AdminHttpOptions): AppWebhookApi {
  const request = createAdminRequest(options);
  return {
    getEndpoint: (appId) => request(`/admin/apps/${encodeURIComponent(appId)}/webhook`, c.adminAppWebhookEndpointSchema),
    upsertEndpoint: (appId, input) => request(`/admin/apps/${encodeURIComponent(appId)}/webhook`, c.adminAppWebhookEndpointSchema, {
      method: "PUT",
      body: JSON.stringify(c.adminAppWebhookUpsertSchema.parse(input)),
    }),
    listDeliveries: (appId, query = {}) => request(
      `/admin/apps/${encodeURIComponent(appId)}/webhook/deliveries?${qs(c.adminAppWebhookDeliveryListQuerySchema.parse(query))}`,
      c.adminAppWebhookDeliveryListResultSchema,
    ),
    sendTest: (appId) => request(`/admin/apps/${encodeURIComponent(appId)}/webhook/test`, c.adminAppWebhookDeliverySchema, { method: "POST" }),
    retryDelivery: (appId, deliveryId) => request(
      `/admin/apps/${encodeURIComponent(appId)}/webhook/deliveries/${encodeURIComponent(deliveryId)}/retry`,
      c.adminAppWebhookDeliverySchema,
      { method: "POST" },
    ),
  };
}
